module.exports = __webpack_public_path__ + "img/dialog_question.ebdb5e9a.svg";